<div *ngIf='localeTexts?.mainNav' class='sso-footer'>
  <div>{{localeTexts?.mainNav[0]?.headline}}</div>
  <div class='sso-footer-links'>
    <div *ngFor='let item of localeTexts?.mainNav[1]?.content'>
      <a [href]='item.url' [target]='item?.newTab?.toLowerCase() === "true" ? "_blank" : "_self"'>
        {{item.text}}
      </a>
    </div>
  </div>
</div>